import React from 'react';
import { Link } from 'gatsby';
import { Helmet } from 'react-helmet';
import { Container } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import 'bootstrap/dist/css/bootstrap.min.css';

import { headData } from '../mock/data';
import '../style/main.scss';

export default () => {
  const { lang } = headData;

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Hit and Pun privacy policy</title>
        <html lang={lang || 'en'} />
        <meta name="description" content="Hit and Pun privacy policy" />
      </Helmet>
      <section id="hero" className="jumbotron">
        <Container>
          <Fade bottom duration={1000} delay={500} distance="30px">
            <h1 className="hero-title text-center">
              Hit and Pun privacy policy{' '}
              <p className="about-wrapper__info-text">
                A friend and I made Hit and Pun as a side project for fun.
              </p>
              <p className="about-wrapper__info-text">
                In Hit and Pun we don't store or have access to any of your personal data - nor are
                we interested in accessing it.
              </p>
              <p className="about-wrapper__info-text">
                If you have any further questions, then feel free to get in touch with us:
                msalemmedev@icloud.com
              </p>
            </h1>
          </Fade>
          <Fade bottom duration={1000} delay={1000} distance="30px">
            <p className="hero-cta justify-content-center">
              <Link className="cta-btn cta-btn--hero" to="/">
                Go back
              </Link>
            </p>
          </Fade>
        </Container>
      </section>
    </>
  );
};
